import {
  SchemaDefinition,
  SchemaTransformError,
  UnknownSchema,
  ViewModel
} from '@rehaje/core'

import type { CSSStyleSheetSpecific } from './TypedNode'

export interface SchemaCSSStyleSheetSpecific extends RehajeSchemaMetadata {
  /**
   * 样式默认配置
   */
  default?: CSSStyleSheetSpecific
  type: 'Schema.CSSStyleSheet'
  /**
   * 值
   */
  value?: any
}

export class SchemaCSSStyleSheetDefinition extends SchemaDefinition {
  override defaultsMerge(
    value: any,
    schema: SchemaCSSStyleSheetSpecific,
    initialize: boolean
  ) {
    if (initialize) {
      if (value === undefined) return schema.default
      return value
    }
    if (schema.required && value === undefined) {
      return schema.default
    }
    return value
  }

  override getIn(schema: SchemaCSSStyleSheetSpecific, path: PropertyKey[]) {
    if (path.length === 0) return schema
    return UnknownSchema
  }

  override infer(
    target: any,
    schema: SchemaCSSStyleSheetSpecific
  ): SchemaCSSStyleSheetSpecific {
    return this.inferOnlySchema({ ...schema, value: target })
  }

  override inferOnlySchema(schema: SchemaCSSStyleSheetSpecific) {
    return schema
  }

  override inferTypeScript(schema: SchemaCSSStyleSheetSpecific): string {
    if (schema.value instanceof ViewModel)
      return super.inferShapeTypeScript(schema.value)
    return this.interface
  }

  override prune(target: any): any {
    return target
  }

  override transform(
    target: any,
    schema: SchemaCSSStyleSheetSpecific,
    path: PropertyKey[] = []
  ) {
    if (this.test(target, schema, path)) return target
    if (target !== schema.fallback)
      this.raise(new SchemaTransformError(schema.name))
    return target
  }

  override validate(target: any, schema: SchemaCSSStyleSheetSpecific) {
    this.validateMetadata(target, schema, (target) => {
      return typeof target === 'function' || this.isRelationSpecific(target)
    })
  }
}

declare global {
  export interface RehajeSpecifics {
    'Schema.CSSStyleSheet': SchemaCSSStyleSheetSpecific
  }
}
